import cardimg1 from "../../assets/images/ARIYA_car_silver.png";
import cardimg2 from "../../assets/images/ARIYA_car_gun matalic.png";
import cardimg3 from "../../assets/images/ARIYA_car_blue.png";
import cardimg4 from "../../assets/images/ARIYA_car_White.png";
import cardimg5 from "../../assets/images/ARIYA_car_red.png";
import cardimg6 from "../../assets/images/ARIYA_CAR_Northern Light Metallic.png";

const engine = (
  <svg
    width="22"
    height="15"
    viewBox="0 0 22 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.3478 3.26113L18.689 3.24849L18.3471 4.08935C18.1572 4.55439 17.904 5.1913 17.7836 5.49688L17.5683 6.05746L17.2581 6.03826L16.9479 6.01906L16.6376 4.93631C16.4731 4.33756 16.302 3.74514 16.2641 3.61144L16.2008 3.37564H14.5611V1.97443H11.9022V1.14644H13.9913V0H5.06471V1.14667H7.15382V1.97466L5.81159 1.98731L4.46308 2.0065L4.444 2.75183L4.42492 3.50348H2.15218V7.26127H1.13951V4.64992H0V10.9558H1.13951L1.15208 9.6628L1.17116 8.37609L1.66504 8.3569L2.15263 8.3377V12.102H4.7419L5.74222 13.4843L6.74884 14.8728L11.4779 14.892L16.2008 14.9047L16.302 14.5734C16.3525 14.3886 16.5173 13.7899 16.6693 13.2485L16.9479 12.2613H17.5683L18.1192 13.6306L18.6636 15H22V3.28033L20.3478 3.26113ZM12.8835 7.91286C12.8776 7.96097 12.8583 8.00637 12.8276 8.04409L9.27951 12.3837C9.25167 12.4185 9.2162 12.4467 9.1758 12.4661C9.13539 12.4855 9.09116 12.4957 9.04604 12.4957C9.00271 12.4957 8.95984 12.4864 8.92033 12.4682C8.88104 12.4501 8.84602 12.4237 8.81818 12.3907C8.79035 12.3579 8.76992 12.3193 8.75869 12.2778C8.74747 12.2362 8.74545 12.1928 8.75286 12.1506V12.1488L9.2079 9.67635H7.44633C7.39739 9.67635 7.34957 9.66257 7.30826 9.63682C7.26696 9.61108 7.23373 9.57404 7.21263 9.53045C7.19153 9.48685 7.18345 9.43807 7.18906 9.38996C7.19467 9.34186 7.2142 9.29646 7.24496 9.25874L10.7926 4.91914C10.833 4.86833 10.8891 4.83219 10.9522 4.81593C11.0153 4.79967 11.0822 4.80441 11.1423 4.82925C11.2025 4.8541 11.2528 4.89791 11.2856 4.9537C11.3183 5.00949 11.3316 5.07453 11.3235 5.13868C11.3235 5.14342 11.3221 5.14816 11.3215 5.1529L10.8649 7.62603H12.6262C12.6751 7.62603 12.723 7.6398 12.7643 7.66555C12.8056 7.6913 12.8388 7.72834 12.8599 7.77193C12.881 7.81552 12.8891 7.86476 12.8835 7.91286Z"
      fill="white"
    />
  </svg>
);

const batteryIcon = (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.49219 14H15.5078C17.149 14 18 13.1602 18 11.5629V4.39422C18 2.797 17.149 1.96465 15.5078 1.96465H14.596V1.01982C14.596 0.382432 14.2161 0 13.5703 0H11.4504C10.797 0 10.4247 0.382432 10.4247 1.01982V1.96465H7.56015V1.01982C7.56015 0.382432 7.18784 0 6.5344 0H4.41452C3.76108 0 3.38877 0.382432 3.38877 1.01982V1.96465H2.49219C0.850992 1.96465 0 2.7895 0 4.39422V11.5629C0 13.1676 0.850992 14 2.49219 14ZM6.542 8.47349C6.542 8.391 6.57999 8.31602 6.64838 8.24103L9.75602 4.41671C10.0068 4.10177 10.4322 4.31923 10.2803 4.70166L9.26973 7.36369H11.1693C11.3212 7.36369 11.458 7.48366 11.458 7.63364C11.458 7.71612 11.42 7.79861 11.344 7.8661L8.24399 11.6904C7.99325 11.9979 7.56775 11.7804 7.71211 11.398L8.73027 8.73594H6.83073C6.67117 8.73594 6.542 8.62346 6.542 8.47349Z"
      fill="white"
    />
  </svg>
);

const carIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.08789 18.1758C14.0713 18.1758 18.1846 14.0625 18.1846 9.08789C18.1846 4.11328 14.0625 0 9.0791 0C4.10449 0 0 4.11328 0 9.08789C0 14.0625 4.11328 18.1758 9.08789 18.1758ZM9.08789 16.3652C5.05371 16.3652 1.82812 13.1221 1.82812 9.08789C1.82812 5.05371 5.05371 1.81934 9.0791 1.81934C13.1133 1.81934 16.3564 5.05371 16.3652 9.08789C16.374 13.1221 13.1221 16.3652 9.08789 16.3652ZM4.38574 11.9443C4.38574 12.2344 4.61426 12.4629 4.91309 12.4629H5.3877C5.67773 12.4629 5.90625 12.2344 5.90625 11.9443V11.2676C6.78516 11.3203 8.05957 11.3643 9.08789 11.3643C10.125 11.3643 11.3994 11.3291 12.2695 11.2676V11.9443C12.2695 12.2344 12.498 12.4629 12.7969 12.4629H13.2627C13.5615 12.4629 13.79 12.2344 13.79 11.9443V9.63281C13.79 8.95605 13.667 8.56934 13.2979 8.10352L12.9551 7.66406C12.8057 6.95215 12.5508 6.21387 12.4189 5.93262C12.1992 5.47559 11.7773 5.20312 11.2412 5.13281C10.96 5.09766 10.125 5.07129 9.08789 5.07129C8.05957 5.07129 7.21582 5.09766 6.93457 5.13281C6.39844 5.19434 5.97656 5.47559 5.76562 5.93262C5.625 6.21387 5.37012 6.95215 5.22949 7.66406L4.87793 8.10352C4.51758 8.56934 4.38574 8.95605 4.38574 9.63281V11.9443ZM6.32812 7.26855C6.40723 6.89062 6.57422 6.41602 6.67969 6.22266C6.78516 6.0293 6.89941 5.9502 7.11914 5.92383C7.38281 5.87988 7.99805 5.8623 9.08789 5.8623C10.1777 5.8623 10.793 5.87988 11.0566 5.92383C11.2852 5.9502 11.3906 6.0293 11.5049 6.22266C11.6191 6.40723 11.7686 6.89062 11.8477 7.26855C11.8916 7.40918 11.8301 7.47949 11.6719 7.4707C11.1094 7.43555 10.4062 7.40039 9.08789 7.40039C7.77832 7.40039 7.0752 7.43555 6.5127 7.4707C6.3457 7.47949 6.29297 7.40918 6.32812 7.26855ZM5.58105 9.63281C5.58105 9.25488 5.8623 8.98242 6.23145 8.98242C6.5918 8.98242 6.88184 9.25488 6.88184 9.63281C6.88184 10.002 6.5918 10.2744 6.23145 10.2744C5.8623 10.2744 5.58105 10.002 5.58105 9.63281ZM11.2939 9.63281C11.2939 9.25488 11.584 8.98242 11.9443 8.98242C12.3135 8.98242 12.5947 9.25488 12.5947 9.63281C12.5947 10.002 12.3135 10.2744 11.9443 10.2744C11.584 10.2744 11.2939 10.002 11.2939 9.63281ZM7.56738 9.65039C7.56738 9.37793 7.76074 9.18457 8.04199 9.18457H10.1338C10.415 9.18457 10.6084 9.37793 10.6084 9.65039C10.6084 9.93164 10.415 10.1162 10.1338 10.1162H8.04199C7.76074 10.1162 7.56738 9.93164 7.56738 9.65039Z"
      fill="#EFEFEF"
    />
  </svg>
);

const Modeldata = [
  {
    id: 1,
    img: cardimg1,
    name: "ENGAGE FWD",
    price: "MSRP: $51,428",
    vorte: "160 kW",
    km: "66 kWh",
    rwd: "FWD",
    icon: carIcon,
    icon2: batteryIcon,
    icon3: engine,
    Alcance: 216,
    MPGe: "109/94/101",
  },
  {
    id: 2,
    img: cardimg2,
    name: "ENGAGE e-4ORCE",
    price: "MSRP: $56,132",
    vorte: "250 kW",
    km: "66 kWh",
    rwd: "e-4ORCE (AWD)",
    icon: carIcon,
    icon2: batteryIcon,
    icon3: engine,
    Alcance: 205,
    MPGe: "109/94/101",
  },
  {
    id: 3,
    img: cardimg3,
    name: "ENGAGE+ e-4ORCE",
    price: "MSRP: $60,835",
    vorte: "290 kW",
    km: "91 kWh",
    rwd: "e-4ORCE (AWD)",
    icon: carIcon,
    icon2: batteryIcon,
    icon3: engine,
    Alcance: 270,
    MPGe: "97/86/92",
  },
  {
    id: 4,
    img: cardimg4,
    name: "VENTURE+ FWD",
    price: "MSRP: $56,132",
    vorte: "178 kW",
    km: " 91 kWh",
    rwd: "FWD",
    icon: carIcon,
    icon2: batteryIcon,
    icon3: engine,
    Alcance: 304,
    MPGe: "111/95/103",
  },
  {
    id: 5,
    img: cardimg5,
    name: "EVOLVE+ FWD",
    price: "MSRP: $59,660",
    vorte: "178 kW",
    km: " 91 kWh",
    rwd: "FWD",
    icon: carIcon,
    icon2: batteryIcon,
    icon3: engine,
    Alcance: 289,
    MPGe: "105/91/98",
  },
  {
    id: 6,
    img: cardimg6,
    name: "EVOLVE+ e-4ORCE",
    price: "MSRP: $64,363",
    vorte: "290 kW",
    km: "91 kWh",
    rwd: "e-4ORCE (AWD)",
    icon: carIcon,
    icon2: batteryIcon,
    icon3: engine,
    Alcance: 270,
    MPGe: "97/86/92",
  },
];
export default Modeldata;
